import { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Button from '@material-ui/core/Button';
import TItemIndividual from '../TItemIndividualHis';
import TItemGrupal from '../TItemGrupalHis';
import { useDispatch } from 'react-redux';
import { obtenerComprasHistorico, obtenerComprasHistoricoGrupal } from "./../../../ducks/finanzasDuck"
import PickerMod from '../../../global/PickersMod';
import { FormatoFecha } from '../../../utils/FormatFecha';
import { onLoadAnction, offLoadAction } from '../../../ducks/loadDuck';
const ItemsPagados = () => {
    const dispatch = useDispatch()
    const [tipoPago, setTipoPago] = useState(true)
    const [selectDayInicio, setSelectedDateInicio] = useState(new Date());
    const onClick = () => {
        setTipoPago(!tipoPago)
    }
    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerComprasHistorico({ fecha: FormatoFecha({ date: selectDayInicio, formato: "MMddyyyy" }) })).then(Response => {
            dispatch(offLoadAction())
        })
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerComprasHistoricoGrupal({ fecha: FormatoFecha({ date: selectDayInicio, formato: "MMddyyyy" }) })).then(Response => {
            dispatch(offLoadAction())
        })
    }, [dispatch, selectDayInicio])

    return (
        <div>
            <Grid container>
                <Grid item xs={12}>
                    <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", gap: "10px" }}>
                        <h3>Tipo de pago</h3>
                        <ButtonGroup disableElevation variant="contained" color="primary">
                            <Button onClick={onClick} color={tipoPago ? 'secondary' : 'default'} >Individual</Button>
                            <Button onClick={onClick} color={!tipoPago ? 'secondary' : 'default'} >Grupal</Button>
                        </ButtonGroup>
                    </div>
                </Grid>
                <Grid item xs={4}>
                    <div style={{ paddingRight: "0" }}>
                        <PickerMod
                            id="fecha"
                            label="Fecha"
                            selectedDate={selectDayInicio}
                            setSelectedDate={setSelectedDateInicio}
                            disablePast={false}
                            disableFuture={false}
                        />
                    </div>
                </Grid>
                <Grid item xs={12}>
                    {
                        (tipoPago) &&
                        <TItemIndividual />
                    }
                    {
                        (!tipoPago) &&
                        <TItemGrupal />
                    }
                </Grid>
            </Grid>
        </div>
    )
}
export default ItemsPagados